function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Cell } from './cell';
import { sum } from '../utils';
export class Col extends Component {
  render() {
    const {
      data,
      style,
      width,
      heightArr,
      flex,
      textStyle,
      ...props
    } = this.props;
    return data ? /*#__PURE__*/React.createElement(View, {
      style: [width ? {
        width: width
      } : {
        flex: 1
      }, flex ? {
        flex: flex
      } : {}, style]
    }, data.map((item, i) => {
      const height = heightArr && heightArr[i];
      return /*#__PURE__*/React.createElement(Cell, _extends({
        key: i,
        data: item,
        width: width,
        height: height,
        textStyle: textStyle
      }, props));
    })) : null;
  }

}
export class Cols extends Component {
  render() {
    const {
      data,
      style,
      widthArr,
      heightArr,
      flexArr,
      textStyle,
      ...props
    } = this.props;
    let width = widthArr ? sum(widthArr) : 0;
    return data ? /*#__PURE__*/React.createElement(View, {
      style: [styles.cols, width ? {
        width
      } : {}]
    }, data.map((item, i) => {
      const flex = flexArr && flexArr[i];
      const wth = widthArr && widthArr[i];
      return /*#__PURE__*/React.createElement(Col, _extends({
        key: i,
        data: item,
        width: wth,
        heightArr: heightArr,
        flex: flex,
        style: style,
        textStyle: textStyle
      }, props));
    })) : null;
  }

}
const styles = StyleSheet.create({
  cols: {
    flexDirection: 'row'
  }
});
//# sourceMappingURL=cols.js.map